import { titleFromAsset, assetTypeGetterMap } from '@/utils';

export default {
  computed: {
    libraryBreadcrumbs() {
      let crumbs = [];
      if (this.tags?.length > 0) {
        let crumbedTags = [];
        this.tags.forEach(t => {
          crumbedTags.push(t);
          crumbs.push({
            name: t.name,
            route: {
              name: 'library#list',
              query: {
                tag: crumbedTags.map(t => t.id),
                nav: this.currentQuery?.nav,
                tagging: this.$route.query?.tagging,
              },
            },
          });
        });
      }
      if (this.libraryAsset) {
        crumbs.push({ name: this.assetTitle(this.libraryAsset) });
      }
      return crumbs;
    },
    tags() {
      if (this.$route.query.tag) {
        if (Array.isArray(this.$route.query.tag)) {
          return this.$route.query.tag.map(t => this.$store.getters['tags/get'][t]);
        } else {
          return [this.$store.getters['tags/get'][this.$route.query.tag]];
        }
      }
    },
  },
  methods: {
    assetByAssetType(type, id) {
      return this.$store.getters[assetTypeGetterMap[type]][id];
    },
    assetTitle(asset) {
      return titleFromAsset(asset, this.assetType);
    },
  },
};
